import React, { useState } from 'react';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import TextField from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

import { useDynamicPromptFGOverride } from '../../../common/hooks/use-dynamic-prompt-fg-override';

const styles = cssMap({
	container: {
		display: 'grid',
		gridTemplateColumns: '1fr 60px',
		columnGap: token('space.100'),
		alignItems: 'center',
	},
});

export const DynamicPromptFGInput = (): React.JSX.Element => {
	const { fgNameFromStore, saveFgNameToStore } = useDynamicPromptFGOverride();
	const [fgName, setFgName] = useState<string>(fgNameFromStore ?? '');

	return (
		<Box xcss={styles.container}>
			<TextField
				placeholder="Feature gate to use as X-Evaluation-Feature-Flag header in the chat stream request"
				value={fgName}
				onChange={(e) => setFgName(e.currentTarget.value)}
			/>
			<Button onClick={() => saveFgNameToStore(fgName)}>Save</Button>
		</Box>
	);
};
